import { render, staticRenderFns } from "./Partes.vue?vue&type=template&id=bacfb582&"
import script from "./Partes.vue?vue&type=script&lang=js&"
export * from "./Partes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports